import { SalesReportByCardTypeItem } from 'store/deliveryLog/types';
import { KioskSales } from 'store/settings/types';

export const mapSalesByCardTypeToKioskSales = (data: SalesReportByCardTypeItem[]): KioskSales[] => {
  return data.map((item) => ({
    externalId: item.kioskId,
    amexTransactionsCount: item.amexTransactionsCount,
    amexTransactionsAmount: item.amexTransactionsAmount,
    nonAmexTransactionsCount: item.nonAmexTransactionsCount,
    nonAmexTransactionsAmount: item.nonAmexTransactionsAmount
  }));
};
